import { WorkflowRole } from '@exam-management/common/types';
import { Divider, Flex, PaperSection, Text } from '@shared/components';
import { useMemo } from 'react';

import { QSetSubTaskDetailsAccordion } from '../../components';
import { useQSetReviewTask, useQSetReviewTaskFormContext } from '../../providers';
import { getQSetReviewTaskAbility, mapSubtaskFormDataToSubtaskDetails } from '../../utils';

export default function QSetSubTaskDetailsAccordionGroup() {
  const {
    mainTaskDetail: {
      subtasks: subtaskDetails,
      examId,
      examCode,
      examTitle,
      id,
      currentWorkflowStep,
    },
    assignedRoles,
  } = useQSetReviewTask();

  const { watch } = useQSetReviewTaskFormContext();

  const subtaskFormData = watch('subtask');

  const sortedGroupedTasks = useMemo(
    () => mapSubtaskFormDataToSubtaskDetails(subtaskFormData, subtaskDetails),
    [subtaskDetails, subtaskFormData],
  );

  const isAddReviewerAllowed = getQSetReviewTaskAbility({
    workflowRoles: assignedRoles,
    status: currentWorkflowStep.code,
    ability: ['ADD_ASSIGNEE'],
    taskType: ['TASK'],
  });

  const isReviewer = assignedRoles.includes(WorkflowRole.SUBTASK_ASSIGNEE);
  const isTaskOwner = assignedRoles.includes(WorkflowRole.TASK_OWNER);
  const isLeadReviewer = assignedRoles.includes(WorkflowRole.TASK_ASSIGNEE);

  return (
    <PaperSection title='Exam Details'>
      <Flex
        sx={(theme) => ({ p: theme.spacing(6), gap: theme.spacing(4), flexDirection: 'column' })}
      >
        <Flex
          sx={(theme) => ({
            border: '1px solid',
            backgroundColor: theme.palette.grey[50],
            p: theme.spacing(4),
            gap: theme.spacing(4),
            borderColor: theme.palette.grey[300],
            borderRadius: theme.shape.rounded(2),
          })}
        >
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(2),
            })}
          >
            <Text variant='body2'>Exam ID: </Text>
            <Text variant='body2Semibold'>{examId}</Text>
          </Flex>
          <Divider orientation='vertical' flexItem />
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(2),
            })}
          >
            <Text variant='body2'>Exam Code: </Text>
            <Text variant='body2Semibold'>{examCode}</Text>
          </Flex>
          <Divider orientation='vertical' flexItem />
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(2),
            })}
          >
            <Text variant='body2'>หลักสูตรทดสอบ: </Text>
            <Text variant='body2Semibold'>{examTitle}</Text>
          </Flex>
        </Flex>
        <Text variant='h5'>
          จำนวนชุดข้อสอบทั้งหมด: {Object.keys(sortedGroupedTasks).length} ชุด
        </Text>
        {Object.entries(sortedGroupedTasks).map(([qSetCode, groupedTasks]) => {
          return (
            <QSetSubTaskDetailsAccordion
              key={qSetCode}
              qSetCode={qSetCode}
              subTasks={groupedTasks}
              taskId={id}
              isAddReviewerAllowed={isAddReviewerAllowed}
              isLeadReviewer={isLeadReviewer}
              isReviewer={isReviewer}
              isTaskOwner={isTaskOwner}
              mainTaskId={id}
            />
          );
        })}
      </Flex>
    </PaperSection>
  );
}
